/* eslint-disable @typescript-eslint/no-namespace */
import { mapEnums } from '../utils/mapping';
import {
  SyndicateRole,
  OrderCategory as OrderCategoryModel,
} from '../types/deal.types';
import * as OrderModels from '../types/order.types';
import { pick } from 'lodash';
import momentTz from 'moment-timezone';

export namespace MuniV2Schema {
  export interface OrderAccountType {
    id: number;
    code: string;
    name: string;
  }

  export interface OrderMoneyType {
    code: string;
    name: string;
  }

  export interface OrderType {
    id: number;
    code: string;
    name: string;
    priorityInd: boolean;
  }

  export enum OrderDepartmentRole {
    seniorManager = 'Senior Manager',
    coSenior = 'Co-Senior Manager',
    coManager = 'Co-Manager',
    sellingGroup = 'Selling Group Member',
    member = 'Member',
    nonManager = 'Non-Manager',
  }

  export interface OrderDepartment {
    id: number;
    name: string;
    role: OrderDepartmentRole;
  }

  export interface OrderCategory {
    id: number;
    code: string;
    name: string;
    priority: number;
    groupCode: string;
    groupName: string;
  }

  export interface Order {
    id: number;
    seriesId: number;
    maturityId: number;
    firmId: number;
    accountName: string;
    zipCode: string;
    orderNumber: string;
    parentWarehouseId: number;
    warehouseId: number;
    repName: string;
    repNumber: string;
    retailInd: boolean;
    amount: number;
    comments: string;
    brokerDealerFirmId: number;
    lastModifiedDate: string;
    accountType?: OrderAccountType;
    moneyType?: OrderMoneyType;
    orderType: OrderType;
    manager?:
      | string
      | {
          name?: string;
          shortName?: string;
          departmentName?: string;
        };
    syndicateDepartment?: OrderDepartment;
    category?: OrderCategory;
  }

  export interface Orders {
    orders: Order[];
    error?: {
      message: string;
      code: string;
      fields: { [key: string]: string };
    };
  }

  export function toOrder(apiData: Order): OrderModels.Order {
    const managerName =
      typeof apiData.manager === 'string'
        ? apiData.manager
        : apiData.manager?.name ||
          apiData.manager?.shortName ||
          apiData.manager?.departmentName;

    return {
      ...pick(apiData, [
        'id',
        'accountName',
        'zipCode',
        'parentWarehouseId',
        'warehouseId',
        'repName',
        'retailInd',
        'comments',
        'firmId',
        'brokerDealerFirmId',
      ]),
      manager: managerName || apiData.syndicateDepartment?.name,
      seriesId: apiData.seriesId && apiData.seriesId.toString(),
      maturityId: apiData.maturityId && apiData.maturityId.toString(),
      amount: apiData.amount * 1000,
      orderNumber: parseInt(apiData.orderNumber, 10),
      repNumber: apiData.repNumber && parseInt(apiData.repNumber, 10),
      lastModifiedDate: momentTz
        .tz(apiData.lastModifiedDate, 'M/D/YYYY H:mm:ss A', 'America/New_York')
        .toDate(),
      moneyType: apiData.moneyType as OrderModels.AccountType,
      orderType: apiData.orderType as OrderModels.OrderType,
      syndicateDepartment: apiData.syndicateDepartment && {
        id: apiData.syndicateDepartment.id,
        name: apiData.syndicateDepartment.name || managerName || '',
        role: mapEnums(apiData.syndicateDepartment.role, SyndicateRole),
      },
      accountType: apiData.accountType as OrderModels.AccountType,
      category: (apiData.category as OrderCategoryModel) || <any>{},
    };
  }
}
